import React, { useContext, useEffect, useState } from 'react';
import './index.css';
import { StoreContext } from '../../store';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { getAllNewsletters } from '../../api';

import DoW from '../../assets/landing-page/media/DoW.jpg';
import Mapping20 from '../../assets/landing-page/media/mapping-20-min.png';
import Walkability3 from '../../assets/landing-page/media/walkability3.png';
import Walkability4 from '../../assets/landing-page/media/walkability4.png';

const walkabilityData = [
  {
    id: 1,
    title: "Sustainability and Walkability #1",
    description:
      "Pedestrians walk for active transportation, leisure, fitness, and mental health. When they do, other dimensions of walkability, beside safety, become important. Here we provide 10 dimensions of walkability gathered from academic literature and popular sources worldwide about what's important to the experience of walking.",
    date: "Sep 22, 2024",
    image: DoW,
    link: "https://www.linkedin.com/posts/activity-7264352470225588225--ehq/?utm_source=share&utm_medium=member_desktop",
  },
  {
    id: 2,
    title: "Sustainability and Walkability #2",
    description:
      "The 20-minute city (one-mile radius) suggests that all lifestyle essentials are within reach. Carlos Moreno, author of the 15-minute City, calls urban proximity as the 21st century approach. Proximity, livability, and social equity are the defining hallmarks of a 20-minute city.",
    date: "Sep 22, 2024",
    image: Mapping20,
    link: "https://www.linkedin.com/posts/activity-7274871045042454529-H7J9/?utm_source=share&utm_medium=member_desktop",
  },
  {
    id: 3,
    title: "Sustainability and Walkability #3",
    description:
      "There is a fair amount of conversation in this platform about having less cars and more people in cities. To enhance people's experience, we must revisit the way we design our sidewalks. We must repurpose them to feel like corridor parks where nature reigns supreme and places where neighbors can look out for one another. Here we present sidewalk MUST-HAVES for polycentric zones or mixed-use areas. They are functional guidelines that when applied creatively, could reflect the unique aspirations among residents in any given neighborhood.",
    date: "Feb 2025",
    image: Walkability3,
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7287167037091512320?updateEntityUrn=urn%3Ali%3Afs_feedUpdate%3A%28V2%2Curn%3Ali%3Aactivity%3A7287167037091512320%29&lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base%3BrOHvljBSTaqpS0zx0UIfVg%3D%3D",
  },
    {
    id: 4,
    title: "Sustainability and Walkability #4",
    description:
      "Smart and sustainable sidewalk technologies are widely available. They offer positive climate change impacts, enhance the experience of walking, and improve safety. Here we present 18 solutions that can be installed along sections of the sidewalk like the building edge, frontage, walkzone, furnishing zone, curbzone, and crosswalk.",
    date: "April 2025",
    image: Walkability4,
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7308925373277220865/?updateEntityUrn=urn%3Ali%3Afs_feedUpdate%3A%28V2%2Curn%3Ali%3Aactivity%3A7308925373277220865%29",
  },
];

const Media = () => {
  const { state, actions } = useContext(StoreContext);
  const { isMobile, announcements } = state;

  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: isMobile ? 1 : 3,
    swipeToSlide: false,
    arrows: true,
  };

  useEffect(() => {
    const fetchData = async () => {
      await actions.fetchAllNewsletters();
    };
    fetchData();
  }, []);

  const walkingAndSustainability = () => {
    return (
      <div className="media-container bg-white pb-16 pt-10">
        <div className="max-w-screen-xl mx-auto px-4">
          <h2 className="text-center text-3xl font-medium mb-12">
            WALKABILITY AND SUSTAINABILITY
          </h2>
          <div className="space-y-8">
            {walkabilityData.map((item) => (
              <a
                key={item.id}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="block transition-transform transform hover:scale-105"
              >
                <div className="flex flex-col md:flex-row items-start gap-8 p-4 text-white bg-[#222f4080]">
                  <div className="md:w-1/3">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full shadow-lg"
                    />
                  </div>
                  <div className="md:w-2/3 h-full">
                    <h3 className="font-bold text-xl">{item.title}</h3>
                    <p className="lg:leading-relaxed mt-4">{item.description}</p>
                    <div className="flex justify-between items-center mt-6">
                      <p className="text-sm text-white">{item?.date}</p>
                      <span className="font-bold hover:underline">
                        Learn more &gt;&gt;
                      </span>
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const newsLetter = () => {
    return (
      <div className="bg-white">
        <section className="py-16 newsletter-container">
          <div className="max-w-screen-2xl mx-auto px-8">
            <div className="flex justify-center items-center mb-8">
              <h2 className="text-3xl font-medium text-center">NEWSLETTER</h2>
            </div>
            <Slider {...settings}>
              {announcements.map((newsletter, index) => (
                <div key={newsletter.id} className="py-4 px-2">
                  <Link to={`/newsletter/${newsletter.id}`} className="block transition-transform transform hover:scale-105 hover:shadow-lg hover:bg-gray-100">
                    <div className="shadow-md overflow-hidden flex flex-col min-h-[400px]">
                      <img
                        src={newsletter?.cover_picture}
                        alt={newsletter.title}
                        className="w-full h-48 object-cover"
                      />
                      <div className="p-4 flex flex-col flex-grow h-[285px] max-h-[285px]">
                        <h3 className="text-lg font-medium">{newsletter.title}</h3>
                        <p className="text-sm mt-2 flex-grow line-clamp-3">
                          {newsletter.description}
                        </p>
                        <div className="flex justify-between items-center mt-auto">
                          <p className="text-gray-500 text-sm">{newsletter.date}</p>
                          <span className="text-blue-500 text-sm font-medium hover:underline">
                            Read more &gt;&gt;
                          </span>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </Slider>
          </div>
        </section>
      </div>
    );
  };

    return (
        <div className='bg-white flex flex-col'>
          <div className="bg-[#1c293a] text-white text-3xl text-center py-12">
            <div className="px-4">MEDIA</div>
          </div>
          {walkingAndSustainability()}
          {newsLetter()}
        </div>
    )
}

export default Media;
